import { Button, Divider, TextField, Theme, Typography } from "@mui/material";
import * as React from "react";

import makeStyles from "@mui/styles/makeStyles";
import { Form, KeyStringValue, Query } from "../interfaces";

const useStyles = makeStyles((theme: Theme) => ({
  manualAddCertButton: {
    "&.MuiButton-containedPrimary": {
      "display": "flex",
      "margin": "1.5rem auto .5rem auto",
      "height": 40,
      "fontSize": "1rem",
      "width": 160,
      "&.Mui-focusVisible, &:hover": {
        backgroundColor: "#ffffff",
        color: theme.palette.primary.main,
      },
      "&:active": {
        backgroundColor: "#7B97BC",
        borderColor: theme.palette.primary.main,
        color: "#fff",
      },
    },
  },
}));

interface Props {
  updateCerts: (certs: string[]) => void;
  currentValue?: string;
  disabled?: boolean;
  fieldName?: string;
  label?: string;
  form?: Form;
  setForm?: React.Dispatch<any>;
  appState?: Query;
  submitCerts?: (certs: any) => void;
}
export default function MultiAddCerts({
  updateCerts,
  currentValue,
  disabled,
  fieldName,
  label,
  form,
  setForm,
  appState,
  submitCerts,
}: Props) {
  const classes = useStyles();
  const [certs, setCerts] = React.useState<string[]>([]);
  const regEx = "^[0-9, ]*$";
  const handleChange = (event: any) => {
    if (RegExp(regEx).test(event.target.value)) {
      setCerts(event.target.value.split(","));
    }
  };
  const handleFormUpdate = (event: any) => {
    let newValue = event.target.value.split(",");
    if (RegExp(regEx).test(newValue)) {
      setCerts(newValue);
      setForm &&
        setForm((prevState: KeyStringValue) => ({
          ...prevState,
          multiCert: newValue.map((cert: string) => cert.replace(/ /g, "")),
        }));
    }
  };
  React.useEffect(() => {
    if (appState?.filters.multiCert) {
      setCerts(appState.filters.multiCert.join(", "));
    }
  }, [appState]);

  return form ? (
    <>
      <TextField
        id="outlined-multiline-flexible"
        label="Enter Certs"
        InputLabelProps={{
          style: { color: "grey" },
        }}
        multiline
        minRows={2}
        fullWidth
        value={certs}
        variant="outlined"
        onKeyDown={e => {
          if (e.key === "Enter" && submitCerts && Array.isArray(certs)) {
            submitCerts(certs);
          }
        }}
        onChange={e => handleFormUpdate(e)}
      />
      <Typography variant="body1" color="primary">
        Enter Certs singly or in multiples separated with commas (e.g., 12345,
        765, 345, etc.)
      </Typography>
    </>
  ) : (
    <form
      style={{ marginBottom: "1.5rem" }}
      onSubmit={(e: any) => {
        e.preventDefault();
        updateCerts(certs.map((cert: string) => cert.replace(/ /g, "")));
        setCerts([]);
      }}
    >
      <TextField
        id="outlined-multiline-flexible"
        label="Enter Certs"
        multiline
        minRows={2}
        fullWidth
        value={certs}
        variant="outlined"
        onChange={e => handleChange(e)}
      />
      <Typography variant="body1" color="primary">
        Enter Certs singly or in multiples separated with commas (e.g., 12345,
        765, 345, etc.)
      </Typography>

      <Divider variant="fullWidth" />
      <Button
        variant="contained"
        color="primary"
        disableElevation
        id="multiAddCertSubmit"
        className={classes.manualAddCertButton}
        type="submit"
      >
        Add to List
      </Button>
    </form>
  );
}
